import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPoliticaValidar() {

    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPoliticaValidar = useCallback(
        (contratoId: string) =>
            invocarApi({
                url: `v1/politica-privacidade/${contratoId}/validar-termo`,
                method: 'GET',
                enviarTokenUsuario: true,
            })
        ,
        [invocarApi],
    );

    return {
        ...outrasPropriedades,
        getPoliticaValidar,
    };

}
